import React, { useState, useEffect } from 'react';
import { login } from '../api/auth';

interface LoginPageProps {
    onLoginSuccess: (token: string, user: any) => void;
    mode: 'KAKAO' | 'SELLER' | 'MASTER';
    title?: string;
}


const LoginPage: React.FC<LoginPageProps> = ({ onLoginSuccess, mode, title }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleKakaoLogin = () => {
        const REDIRECT_URI = window.location.origin;

        // Store the current path to return to after login
        const currentPath = window.location.pathname;
        if (currentPath && currentPath !== '/') {
            localStorage.setItem('return_path', currentPath);
        }

        // Use manual redirection with proper encoding (REST API flow)
        // This avoids 'js_client_not_allowed' error on mobile
        const RAW_KEY = import.meta.env.VITE_KAKAO_API_KEY || '';
        const REST_API_KEY = RAW_KEY.trim();
        const ENCODED_URI = encodeURIComponent(REDIRECT_URI);
        const KAKAO_AUTH_URL = `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${REST_API_KEY}&redirect_uri=${ENCODED_URI}`;
        window.location.href = KAKAO_AUTH_URL;
    };

    const handleSellerLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const response = await login(username, password);
            onLoginSuccess(response.access_token, response.user);
        } catch (err) {
            console.error(err);
            setError('아이디 또는 비밀번호가 올바르지 않습니다.');
        }
    };

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
            <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8">
                <h1 className="text-2xl font-black text-center text-gray-900 mb-8">
                    장봐드림 서비스<br /><span className="text-emerald-500">
                        {title || (mode === 'KAKAO' ? '로그인' : '판매자 로그인')}
                    </span>
                </h1>

                {error && <div className="bg-red-50 text-red-500 text-xs p-3 rounded-lg mb-4">{error}</div>}

                {mode === 'KAKAO' ? (
                    <div className="space-y-4">
                        <p className="text-center text-gray-500 text-sm mb-4">
                            카카오 계정으로 간편하게 로그인하세요.
                        </p>
                        <button
                            onClick={handleKakaoLogin}
                            className="w-full h-12 bg-[#FEE500] hover:bg-[#FDD835] text-[#3c1e1e] font-bold rounded-xl flex items-center justify-center gap-2 transition-colors"
                        >
                            <svg viewBox="0 0 24 24" width="20" height="20" className="opacity-90"><path d="M12 3C6.48 3 2 6.48 2 10.77C2 13.62 3.82 16.14 6.55 17.5L5.5 21L9.12 18.25C10.04 18.45 11 18.54 12 18.54C17.52 18.54 22 15.06 22 10.77C22 6.48 17.52 3 12 3Z" fill="currentColor" /></svg>
                            카카오로 시작하기
                        </button>
                    </div>
                ) : (
                    <form onSubmit={handleSellerLogin} className="space-y-4">
                        <div>
                            <label className="block text-xs font-bold text-gray-500 mb-1">아이디</label>
                            <input
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                className="w-full h-12 px-4 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none transition-all"
                                placeholder="아이디를 입력하세요"
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-500 mb-1">비밀번호</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full h-12 px-4 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none transition-all"
                                placeholder="비밀번호를 입력하세요"
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full h-12 bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-xl shadow-lg shadow-emerald-100 transition-all"
                        >
                            로그인
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default LoginPage;